module.exports = __webpack_public_path__ + "img/1f60c.6c1e804.svg";